<div class="flex-container gap-6" style="height: 100%">
  <vl-widget-title
    [text]="'stats.synthese_mouvements' | trans"
    [widget]="widget()"
    [draggable]="false"
    [editable]="false"
    [filter]="true"
  >
    <ng-content class="drag-handler" select=".drag-handler"></ng-content>

    <!-- Bouton filtre dans le header -->
    <ng-content class="filter" select=".filter">
      <vl-chips
        size="small"
        iconLeft="settings"
        (action)="trigger.attachOverlay()"
        [popoverTrigger]="filters"
        #trigger="popoverElement"
        [closeOnClickOutside]="true"
        state="enabled"
      >
        {{ "button.filter" | trans }}
      </vl-chips>
    </ng-content>
  </vl-widget-title>

  <!-- Popover: juste le switch vue -->
  <ng-template #filters>
    <div class="flex-col w100 gap-8 justup-card p-8 up-3">
      <div class="caption-2 on-background-alt">Affichage</div>
      <vl-chips-toggle
        [(value)]="viewType"
        [elements]="elementsView"
      ></vl-chips-toggle>
    </div>
  </ng-template>

  @if (metadata()?.loading) {
    <div class="widget-content h100 overflow-hidden">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
              height: '220px',
              'background-color': 'var(--color-on-disabled)',
            }"
      />
    </div>
  } @else {

    @if (!display()) {
      <div class="widget-content empty">
        <div class="caption on-disabled">Aucun mouvement sur la période / filtres.</div>
      </div>
    } @else {
      <!-- Graph -->
      <div class="widget-content fade-in" [hidden]="viewType() === 'LIST'">

        <div class="h100 fade-in">
          <canvas #mv style="width:100%;height:100%;display:block;"></canvas>
        </div>
      </div>

      <!-- Liste -->
        <!-- Liste -->
      @if (viewType() === 'LIST') {
        <div class="widget-content fade-in" style="width:100%; overflow-x:auto;">
          <table class="ju-table" style="min-width:520px; width:100%">
            <thead>
            <tr>
              <th class="col-type">Type</th>
              <th class="col-qty right">Quantité</th>
            </tr>
            </thead>

            <tbody>
              @for (r of rows(); track r.key) {
                <tr class="table-row border-bottom-outline-opacity-50">
                  <td class="col-type on-background">{{ r.label }}</td>
                  <td class="col-qty right on-background">{{ fmt(r.value) }}</td>
                </tr>
              }

            <tr class="row-total">
              <td class="strong">Net (Entrées - Sorties)</td>
              <td class="right strong">{{ fmt(netTotal()) }}</td>
            </tr>

            </tbody>
          </table>
        </div>
      }
    }

  }
</div>
